"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ReplicationRules_1 = require("./_ReplicationRules");
exports._ReplicationConfiguration = {
    type: "structure",
    required: ["Role", "Rules"],
    members: {
        Role: {
            shape: {
                type: "string"
            }
        },
        Rules: {
            shape: _ReplicationRules_1._ReplicationRules,
            locationName: "Rule"
        }
    }
};
//# sourceMappingURL=_ReplicationConfiguration.js.map